function addStyles(filler:HTMLElement, header:HTMLElement) {
  if (filler && header) {
    const headerPos = header.getBoundingClientRect();
    filler.style.width = `${headerPos.x + 500}px`; // eslint-disable-line
  }
}

export default function setHeroStyling() {
  // @ts-ignore
  const filler:HTMLElement = document.getElementById('heroSectionFiller');
  // @ts-ignore
  const header:HTMLElement = document.querySelector('header.header .wrapper');

  addStyles(filler, header);
  window.addEventListener('resize', () => {
    addStyles(filler, header);
  }, { passive: true });
}
